export const DEFAULT_LAYOUT = 'WhiteEmptyLayout';

export const APPLICATION_LAYOUT = 'ApplicationLayout';
